// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestDirectorySearch-cls1_Hx-","cls2":"ResearchInterestDirectorySearch-cls2_Eyr ResearchInterestDirectorySearch-cls1_Hx-"};